export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Slider Input';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const labelRow = document.createElement('div');
  labelRow.className = 'ew-input-row';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Adjust value';

  const readout = document.createElement('span');
  readout.className = 'ew-input-readout';

  labelRow.append(label, readout);

  const input = document.createElement('input');
  input.type = 'range';
  input.min = node.props?.min ?? 0;
  input.max = node.props?.max ?? 100;
  input.step = node.props?.step ?? 1;
  input.value = node.data?.value ?? node.props?.value ?? input.min;

  const formatValue = (value, unit) => `${value}${unit ? ` ${unit}` : ''}`;

  const updateReadout = (unitOverride) => {
    const unit = unitOverride ?? node.props?.unit ?? '';
    readout.textContent = formatValue(input.value, unit);
  };

  const onInput = () => {
    api.setData({ value: Number(input.value) });
    api.emit('node:input', { id: node.id, field: 'value', value: Number(input.value) });
    updateReadout();
  };

  input.addEventListener('input', onInput);
  input.addEventListener('change', onInput);
  updateReadout();

  body.append(labelRow, input);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Slider Input';
      label.textContent = next.props?.label || 'Adjust value';
      input.min = next.props?.min ?? 0;
      input.max = next.props?.max ?? 100;
      input.step = next.props?.step ?? 1;
      const nextValue = next.data?.value ?? next.props?.value ?? input.min;
      if (String(input.value) !== String(nextValue)) input.value = nextValue;
      readout.textContent = formatValue(nextValue, next.props?.unit || '');
    },
    cleanup: () => {
      input.removeEventListener('input', onInput);
      input.removeEventListener('change', onInput);
    }
  };
}
